
export {localStorageManager} from './localStorage';



// WEBPACK FOOTER //
// ./src/app/redux/middleware/index.js